import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { WjGridModule } from '@grapecity/wijmo.angular2.grid';
import { WjNavModule } from '@grapecity/wijmo.angular2.nav';
import { WjInputModule } from '@grapecity/wijmo.angular2.input';
import { PlessSharedModule } from '../../../../shared/pless-shared.module';
import { AppCommonsModule } from '../../../../commons/app-commons.module';

import { KYMW5002SearchResultComponent } from './kymw5002-search-result.component';
import { ImageInfoRendererModule } from '../image-info-renderer/image-info-renderer.module';

/**
 * EC使用画像指示画面 モジュール設定クラス
 *
 * @export KYMW5002SearchResultModule
 * @class KYMW5002SearchResultModule
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
    WjGridModule,
    WjNavModule,
    WjInputModule,
    ImageInfoRendererModule,
  ],
  declarations: [
    KYMW5002SearchResultComponent,
  ],
  providers: [
  ],
  exports: [
    KYMW5002SearchResultComponent,
  ]
})
export class KYMW5002SearchResultModule {

}
